export default "__VITE_ASSET__R9_CrIyA__"